package one.healthium.uscreen.domain.models

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
enum class UScreenFontWeight {
    @SerialName("normal") Normal,
    @SerialName("bold") Bold,
    @SerialName("semibold") SemiBold,
}
